module.exports = __webpack_public_path__ + "static/media/unarchive.01bc6970.svg";